import { getLadderHeightConfig, getLadderScale } from './utils';

/** Как в core.js: от pivot группы до верхней кромки лестницы у борта. */
const LADDER_TOP_DROP = 0.49;

/** Доп. подъём подписи над верхом bbox (м), фиксированно для всех моделей. */
export const LADDER_DIMENSION_LABEL_EXTRA_ABOVE_TOP = 0.06;

/** Фиксированный yaw подписи — лестница всегда в одном углу, авто-поворот к центру не нужен. */
export const LADDER_DIMENSION_LABEL_ROTATION = [0, Math.PI, 0];

/**
 * Y-якорь подписи «Размеры»: верх 3D-модели от pivot (position[1]), не wallTopY.
 * @param {{ position?: number[], scale?: number[], ladder?: { modelPath?: string }, modelPath?: string }} instance
 * @returns {number}
 */
export function computeLadderDimensionLabelAnchorY(instance) {
  const pos = instance?.position;
  if (!pos || pos.length < 3) return 0;

  const modelPath =
    instance.ladder?.modelPath || instance.modelPath || '/models/ladders/ladder10.glb';
  const scale = instance.scale || getLadderScale(modelPath);
  const scaleY = Array.isArray(scale) ? (scale[1] ?? 1) : 1;
  const ladderTopOffset = getLadderHeightConfig(modelPath);
  const topAbovePivot = ladderTopOffset * scaleY + LADDER_TOP_DROP;

  return pos[1] + topAbovePivot;
}
